import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import PostDislikesModalState from '../states/PostDislikesModalState';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class PostDislikesModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.state = new PostDislikesModalState({
      filter: {
        disliked: this.attrs.post.id()
      }
    });
    this.state.refresh();
  }
  className() {
    return 'PostDislikesModal Modal--small';
  }
  title() {
    return app.translator.trans('nodeloc-dislikes.forum.post_dislikes.title');
  }
  content() {
    return m('[', null, m("div", {
      className: "Modal-body"
    }, this.state.isInitialLoading() ? m(LoadingIndicator, null) : m("ul", {
      className: "PostDislikesModal-list"
    }, this.state.getPages().map(page => page.items.map(user => m("li", null, m(Link, {
      href: app.route.user(user)
    }, m(Avatar, {
      user: user
    }), " ", username(user))))))), this.state.hasNext() ? m("div", {
      className: "Modal-footer"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--block",
      onclick: () => this.state.loadNext(),
      loading: this.state.isLoadingNext()
    }, app.translator.trans('nodeloc-dislikes.forum.post_dislikes.load_more_button'))))) : null);
  }
}
flarum.reg.add('nodeloc-dislikes', 'forum/components/PostDislikesModal', PostDislikesModal);